import React from 'react';
import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './Footer.module.scss';

function Footer({ changeColor, iconsColor }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`${classes.footer} ${classes[changeColor]}`}>
      <div className={`${classes.lineSeperate} ${classes[changeColor]}`} />
      <div className={classes.privacyMediaPosition}>
        <div>
          <span className={`${classes.privacyStyle} ${classes[changeColor]}`}>
            Privacy Policy
          </span>
          <span className={`${classes.dateLLc} ${classes[changeColor]}`}>
            © {currentYear} Moobitek, LLC.
          </span>
        </div>
        <div className={classes.mediaPositions}>
          <a
            href="https://www.facebook.com/Moobitek"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faFacebookF}
              color={iconsColor === 'black' ? 'black' : 'white'}
              className={classes.mediaIcon}
            />
          </a>
          <a
            href="https://twitter.com/i/flow/login?redirect_after_login=%2Fmoobitek"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faXTwitter}
              color={iconsColor === 'black' ? 'black' : 'white'}
              className={classes.mediaIcon}
            />
          </a>
          <a
            href="https://www.linkedin.com/company/moobitek"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              color={iconsColor === 'black' ? 'black' : 'white'}
              className={classes.mediaIcon}
            />
          </a>
          <a
            href="https://www.instagram.com/moobitek.leb"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon
              icon={faInstagram}
              color={iconsColor === 'black' ? 'black' : 'white'}
              className={classes.mediaIcon}
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
